import React, { useMemo, useState } from 'react'

import CloseIcon from '@mui/icons-material/Close'
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  useTheme,
} from '@mui/material'
import { isArray } from 'lodash'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { useAppDispatch } from '../../store/hooks'
import { useIsMobile } from '../../utils/useIsMobile'
import { CustomButton } from '../CustomButton'
import { CustomTabs, TabType } from '../Tabs'

import { groupByWorksheet } from './helpers'
import selectors from './redux/selectors'
import { clearXlsxValidationErrors } from './redux/XlsxValidationSliceReducer'
import XlsxValidatonTableWidget from './XlsxValidatonTableWidget'

const XlsxValidationAlert = () => {
  const { t } = useTranslation()

  const { spacing } = useTheme()
  const fullScreen = useIsMobile('md')

  const dispatch = useAppDispatch()

  const errors = useSelector(selectors.errors)

  const isOpen = isArray(errors) && errors?.length > 0

  const [activeTab, setActiveTab] = useState<number>(0)

  const onClose = () => {
    dispatch(clearXlsxValidationErrors())
    setActiveTab(0)
  }

  const errorsByWorksheets = useMemo(() => groupByWorksheet(errors), [errors])

  const tabs: TabType<string>[] = errorsByWorksheets?.map(({ worksheet }) => ({
    key: worksheet,
    label: worksheet,
  }))

  const tabRows = errorsByWorksheets[activeTab]?.rows

  return (
    <Dialog open={isOpen} onClose={onClose} fullScreen={fullScreen} maxWidth={'lg'}>
      <DialogTitle>{t('xlsxValidation.alert.title')}</DialogTitle>
      <IconButton className="close-button" aria-label="close" onClick={onClose}>
        <CloseIcon />
      </IconButton>
      <DialogContent dividers sx={{ minWidth: fullScreen ? 'auto' : spacing(100) }}>
        <CustomTabs tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />

        <Box mt={2}>
          <XlsxValidatonTableWidget list={tabRows} fullHeight />
        </Box>
      </DialogContent>

      <DialogActions>
        <CustomButton color="secondary" onClick={onClose}>
          {t('xlsxValidation.alert.action.close')}
        </CustomButton>
      </DialogActions>
    </Dialog>
  )
}

export default XlsxValidationAlert
